<div class="container d-block d-sm-none mobile-menu" *ngIf="this.isMobile">
    <div class="row">
      <div class="col-12 mobileButtonMenu d-flex  pb-1 pt-2">
  
        <a href="javascript:void(0);" [routerLink]="['/']">
          <div class="mobileButtonMenu__item d-flex">
            <i class="icon-search"></i>
            <p class="py-0 my-0 fw-light">Cerca</p>
          </div>
        </a>
  
        <ng-container *ngIf="isLogged; else notLoggedMenu">
          <a href="javascript:void(0);" [routerLink]="['/utente-annunci']">
            <div class="mobileButtonMenu__item d-flex">
                <i class="icon-heart"></i>
                <p class="py-0 my-0 fw-light">Salvati</p>
            </div>
          </a> 
    
          <a href="javascript:void(0);" [routerLink]="['/utente-ricerche']">
            <div class="mobileButtonMenu__item d-flex">
              <i class="icon-compass"></i>
              <p class="py-0 my-0 fw-light">Ricerche</p>
            </div>
          </a>

          <a *ngIf="this.showNews"  href="javascript:void(0);" [routerLink]="['/news']">
            <div class="mobileButtonMenu__item d-flex">
              <i class="icon-newspaper"></i>
              <p class="py-0 my-0 fw-light">News</p>
            </div>
          </a>
    
          <a href="javascript:void(0);" [routerLink]="['/utente']">
            <div class="mobileButtonMenu__item d-flex">          
                <i class="icon-user-circle"></i>
                <p class="py-0 my-0 fw-light">Menù</p>
            </div>
          </a>
        </ng-container>

        <ng-template #notLoggedMenu>
          <div class="cursor-pointer" href="javascript:void(0);">
            <div class="mobileButtonMenu__item d-flex">
              <i class="icon-history"></i>
              <p class="py-0 my-0 fw-light" [routerLink]="['/annunci-visitati']">Recenti</p>
            </div>
          </div>

          <a *ngIf="this.showNews"  href="javascript:void(0);" [routerLink]="'/news'">
            <div class="mobileButtonMenu__item d-flex">
              <i class="icon-newspaper"></i>
              <p class="py-0 my-0 fw-light">News</p>
            </div>
          </a>
    
          <div class="cursor-pointer" href="javascript:void(0);" (click)="this.openPopup()">
            <div class="mobileButtonMenu__item d-flex">          
                <i class="icon-user-circle"></i>
                <p class="py-0 my-0 fw-light">Menù</p>
            </div>
          </div>
        </ng-template>
        
      </div>
    </div>
</div>

<app-popup
    *ngIf="this.modalIsOpen"
    (closePopupEvent)="this.closePopup()"
    [modalIsOpen]="this.modalIsOpen" 
    [reviewFormIsValid]="true" 
    [isReviewPage]="false"
    [formValue]="this.formValue"
>
</app-popup>